import { scrollToPanelElement } from "../../components/sectionScroll";

// 依頼/取消・帳票出力・メニュー操作・品番確定などの画面アクションをまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createHinbanActionService(deps) {
    const {
        AGRef,
        Delete,
        DicVal,
        EntrybodyRef,
        FIXED_HINBAN_NUMBERING_COLUMNID,
        G_id,
        GridApi,
        HINBAN_NUMBERING_FAILED_MESSAGE,
        LayoutSaveStorage,
        LoadData,
        Save,
        activeKakousijiSummaryItem,
        assignEntryDataCurrent,
        baseref,
        buildCurrentHinbanSavePayload,
        cfFileUpload,
        clearform,
        columninfo,
        confirmPdtcSkuNameSyncOnSave,
        controller,
        dispatch,
        ensureBrandHinbanValuesOnSave,
        ensureOppiHinbanAssigned,
        ensureSubBrandValuesOnSave,
        entrydata,
        entrydataRef,
        entrylock,
        fnc,
        hinbanFixEnabled,
        isEmpty,
        isEnabled,
        navmenu,
        panel,
        primarykeys,
        resolveCurrentOppiCode,
        runAfterActiveInputCommit,
        setHinbanFixEnabled,
        tabletype,
        textfields
    } = deps;

    function normalizeRequestFlagForMenu(value) {
        const reqFlg = String(isEmpty(value) ? "" : value).trim();
        if (reqFlg === "0" || reqFlg === "未申請") return "0";
        if (reqFlg === "1" || reqFlg === "申請済" || reqFlg === "申請中") return "1";
        return "";
    }
    function requestStatusNavMenu() {
        const reqFlg = normalizeRequestFlagForMenu(DicVal(entrydataRef.current, "PDT_REQFLG", ""));
        return navmenu.filter((item) => {
            if (item.menuid === "shinsei") return reqFlg === "0";
            if (item.menuid === "shinseikaijo") return reqFlg === "1";
            return true;
        });
    }
    function currentRequestStatusNavMenu() {
        return entrylock ? requestStatusNavMenu().filter(e => e.menuid !== 'formupload') : requestStatusNavMenu();
    }
    function Jump(id, type) {
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        // 実際にスクロールしている側(コンテナ/ウィンドウ)を判定して移動する共通処理。
        scrollToPanelElement(EntrybodyRef.current, elem);
    }
    function RequestHinbanEntry(nocheck, skipPdtcSkuNameConfirm) {
        runAfterActiveInputCommit(() => {
            const oppiCode = resolveCurrentOppiCode();
            if (isEmpty(oppiCode)) {
                fnc.current.warnmsg("申請対象の品番が取得できません。先に品番を登録してください。");
                return;
            }

            const showNumberingFailedMessage = function () {
                fnc.current.wait(false);
                fnc.current.warnmsg(HINBAN_NUMBERING_FAILED_MESSAGE);
            };
            ensureBrandHinbanValuesOnSave(
                () => ensureSubBrandValuesOnSave(() => confirmPdtcSkuNameSyncOnSave(() => continueRequestHinbanEntry(oppiCode, nocheck), skipPdtcSkuNameConfirm)),
                showNumberingFailedMessage
            );
        });
    }
    function continueRequestHinbanEntry(oppiCode, nocheck) {
        const savePayload = buildCurrentHinbanSavePayload(nocheck);
        if (isEmpty(savePayload)) return;
        const { paramdata, newfiles } = savePayload;
        paramdata.code = oppiCode;
        paramdata.data = {
            ...(isEmpty(paramdata.data) ? {} : paramdata.data),
            PDT_OPPICD: oppiCode,
            [FIXED_HINBAN_NUMBERING_COLUMNID]: DicVal(entrydataRef.current, FIXED_HINBAN_NUMBERING_COLUMNID, "")
        };

        fnc.current.postaxios('hinbanmaster/RequestHinbanEntry', paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        const code = isEmpty(data.request) ? oppiCode : data.request;
                        if (!isEmpty(entrydataRef.current)) {
                            assignEntryDataCurrent({
                                ...entrydataRef.current,
                                PDT_REQFLG: "1"
                            }, "RequestHinbanEntry");
                            dispatch(entrydata({ ...entrydataRef.current }));
                        }
                        if (newfiles.length !== 0) {
                            cfFileUpload("hinbanmaster", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            LoadData(code);
                        }
                        fnc.current.wait(false);
                        return;
                    }

                    if (isEnabled(data.confirm)) {
                        var msgs = [];
                        for (let i = 0; i < data.warning.length; i++) {
                            msgs.push("・" + data.warning[i].message);
                        }
                        fnc.current.confmsg(msgs, () => RequestHinbanEntry(true, true));
                    } else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                },
                errmsg: "申請処理に失敗しました"
            }
        );
    }
    function CancelHinbanRequestEntry() {
        runAfterActiveInputCommit(() => {
            const oppiCode = resolveCurrentOppiCode();
            if (isEmpty(oppiCode)) {
                fnc.current.warnmsg("申請解除対象の品番が取得できません。先に品番を登録してください。");
                return;
            }

            const requestData = {
                ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
                PDT_OPPICD: oppiCode
            };
            const requestParam = { controller: controller, code: oppiCode, data: requestData };
            fnc.current.postaxios('hinbanmaster/CancelHinbanRequestEntry', requestParam,
                {
                    onSuccess: function (data) {
                        if (!isEmpty(entrydataRef.current)) {
                            assignEntryDataCurrent({
                                ...entrydataRef.current,
                                PDT_REQFLG: "0"
                            }, "CancelHinbanRequestEntry");
                            dispatch(entrydata({ ...entrydataRef.current }));
                        }
                        fnc.current.success();
                        LoadData(oppiCode);
                    },
                    onError: function (data) {
                        fnc.current.wait(false);
                        let msg = "処理に失敗しました";
                        if (!isEmpty(data.errDescription)) {
                            msg = data.errDescription;
                        }
                        fnc.current.warnmsg(msg);
                    },
                    errmsg: "申請解除処理に失敗しました"
                }
            );
        });
    }
    function ResolveTehaiReportUrl(action) {
        if (action === 'sozaitenhaisho') return 'SozaiTehaiShoReport/Generate';
        if (action === 'fuzokutenhaisho') return 'FuzokuTehaiShoReport/Generate';
        if (action === 'fukushizaitenhaisho') return 'FukushizaiTehaiShoReport/Generate';
        return '';
    }
    function PrintTehaiReport(action) {
        const url = ResolveTehaiReportUrl(action);
        if (isEmpty(url)) return;

        const activeItem = activeKakousijiSummaryItem();
        const ssdNo = String(DicVal(activeItem, 'code', '')).trim();

        if (isEmpty(ssdNo) || DicVal(activeItem, 'isDraft', false)) {
            fnc.current.warnmsg('帳票発行対象の加工指示番号が取得できません。');
            return;
        }

        const param = {
            controller: controller,
            id: action,
            denNo: ssdNo
        };

        fnc.current.postaxios(url, param,
            {
                onSuccess: function (data) {
                    const downloadParam = {
                        excelfile: data.returnData['filename'],
                        dnfile: data.returnData['dnfile']
                    };
                    fnc.current.filedownload('excel/ExcelDownload', downloadParam);
                    fnc.current.wait(false);
                },
                errmsg: '帳票の発行に失敗しました'
            }
        );
    }
    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'shinsei') {
            RequestHinbanEntry();
            return;
        }
        if (action === 'shinseikaijo') {
            CancelHinbanRequestEntry();
            return;
        }
        if (action === 'sozaitenhaisho' || action === 'fuzokutenhaisho' || action === 'fukushizaitenhaisho') {
            PrintTehaiReport(action);
            return;
        }
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (action === "print") {  //納品予定出力
            let code = [];
            let param = baseref.current?.GetSelectrowdata();
            if (param.length === 0) {
                fnc.current.warnmsg("対象データを選択してください");
                return;
            }
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    for (let j = 0; j < param.length; j++) {
                        code.push(param[j][primarykeys[i]]);
                    }
                    break;
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('HinbanNouhinYoteiReport/Generate', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action == "imagesave") {
            fnc.current.warnmsg("未実装");
        }
    }
    function confirmHinbanEntry(oppiCode) {
        const requestCode = String(isEmpty(oppiCode) ? "" : oppiCode).trim();
        if (isEmpty(requestCode)) {
            fnc.current.wait(false);
            fnc.current.warnmsg("品番確定対象のPS品番が取得できません。先に登録してください。");
            return;
        }

        const requestParam = {
            code: requestCode,
            controller: controller,
            colinfo: columninfo,
            data: {
                ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
                PDT_OPPICD: requestCode
            }
        };
        fnc.current.postaxios("hinbanmaster/ConfirmHinbanEntry", requestParam,
            {
                onSuccess: function (data) {
                    if (Array.isArray(data.warning) && data.warning.length !== 0) {
                        const message = String(DicVal(data.warning[0], "message", "JANコードが設定できませんでした。")).trim();
                        fnc.current.wait(false);
                        fnc.current.warnmsg(message === "" ? "JANコードが設定できませんでした。" : message);
                        return;
                    }
                    fnc.current.successmsg("品番確定しました。");
                    setHinbanFixEnabled(false);
                    LoadData(requestCode);
                },
                onError: function (data) {
                    const message = String(DicVal(data, "errDescription", "")).trim();
                    fnc.current.wait(false);
                    fnc.current.warnmsg(message === "" ? "JANコードが設定できませんでした。" : message);
                },
                errmsg: "品番確定に失敗しました"
            }, true
        );
    }
    function handleHinbanChatClick() {
        // Placeholder: chat action will be implemented later.
    }
    function handleHinbanFixClick() {
        if (!hinbanFixEnabled) return;
        fnc.current.wait(true);
        ensureOppiHinbanAssigned({
            showSuccessMessage: false,
            onSuccess: function (oppiCode) {
                confirmHinbanEntry(oppiCode);
            },
            onError: function () {
                fnc.current.wait(false);
            }
        });
    }

    return {
        normalizeRequestFlagForMenu,
        requestStatusNavMenu,
        currentRequestStatusNavMenu,
        Jump,
        RequestHinbanEntry,
        continueRequestHinbanEntry,
        CancelHinbanRequestEntry,
        ResolveTehaiReportUrl,
        PrintTehaiReport,
        MenuAction,
        confirmHinbanEntry,
        handleHinbanChatClick,
        handleHinbanFixClick
    };
}
